import template from './atm_count.html';
import controller from './atm_count.controller';
import './atm_count.scss';

let ATMCountComponent = {
    restrict: 'E',
    template,
    controller
};

export default ATMCountComponent;



// WEBPACK FOOTER //
// ./client/app/components/atm_count/atm_count.component.js